import { app } from '../app.module'
app
  /**
   * escapeHTML htmlタグをエスケープ
   * @param  {String} text メッセージ
   * @return {String} エスケープしたテキスト
   */
  .filter('escapeHTML', () => {
    return function escapeHTML(text) {
      // テキストが存在しない場合、終了
      if (text === undefined || text === null) {
        return
      }
      return text
        .replace(/&/g, '&amp;')
        .replace(/'/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
    }
  })
  /**
   * postBody 投稿本文のURL文字列やハッシュタグ文字列をリンク化
   * @param  {String} text メッセージ
   * @param  {String} snsType   SNS種類
   * @return {String} 置き換えたHTML要素
   */
  .filter('postBody', ($sce) => {
    return function postBody(text: string, snsType: string) {
      // テキストが存在しない場合、終了
      if (text === undefined || text === null) {
        return
      }

      // ハッシュタグに含めない文字列をセット (半角,全角)
      const halfSizeSymbol = '!"#$%\'()*+,-./:;<=>?@[\\]^`{|}~\b\n\r\f\t\x20'
      const fullSizeSymbol =
        '”：；？＃！％＊’´｀¨＆＾￣＿／（）〔〕［］｛｝〈〉《》「」『』【】＋－±×÷＝＜＞￥＠＄￠，．　。'
      // ハッシュタグ
      let hashtagRegex = new RegExp(
        '((?:^)|([' +
          halfSizeSymbol +
          fullSizeSymbol +
          ']))([#＃])([^&' +
          halfSizeSymbol +
          fullSizeSymbol +
          ']{1,100})',
        'g'
      )

      // プレビューでURLの表示処理
      function showUrl(url: string) {
        // リンクにhttp(s)が含まれない場合、http://を追加
        const urlHref = url.match(/https?/) !== null ? url : 'http://' + url

        // twitterの場合、リンクからhttp(s)を解除
        if (snsType === 'twitter') {
          url = url.replace(/https?:\/\//, '')
        }

        return '<a href="' + urlHref + '" target="_blank">' + url + '</a>'
      }

      // Facebookの場合
      if (snsType === 'facebook') {
        // URlregex
        const fbUrlRegex =
          /((((https?|ftp):\/\/)?([a-zA-Z0-9\-\.])+(\.)+(com|edu|gov|net|org|uk))|((((https?|ftp):\/\/)|(www\.))+([a-zA-Z0-9\-\.])+(\.)+(aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cs|cu|cv|cx|cy|cz|dd|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw)))(\/[-a-zA-Z\d%_.~+]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(\#[-a-zA-Z\d_]*)?(\@[-a-zA-Z\d_]*)?\b(\/)?/g

        // URLドメイン
        text = text.replace(fbUrlRegex, showUrl).trim()

        // ハッシュタグをフィルタリング
        text = text.replace(
          hashtagRegex,
          '$2<a href="https://www.facebook.com/hashtag/$4" target="_blank">$3$4</a>'
        )

        return $sce.trustAsHtml(text)
      }

      // Twitterの場合
      if (snsType === 'twitter') {
        // URlregex:プロトコル & ドメイン & パス & クエリーストリング (ドメインは必要です。他の部分はなくても大丈夫です)
        // プロトコル: http | https
        // ドメイン: 英数字 & . & 指定ドメイン
        // ドメイン以降のパス: 英数字
        const twUrlRegex =
          /(https?:\/\/)?([a-zA-Z0-9\-\.])+(\.)+(aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cs|cu|cv|cx|cy|cz|dd|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw)(\/[-a-zA-Z\d%_.~+]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(\#[-a-zA-Z\d_]*)?(\@[-a-zA-Z\d_]*)?\b(\/)?/g
        // URLドメイン
        text = text.replace(twUrlRegex, showUrl)

        const twitterUserRegex = new RegExp(
          '((?:^)|([^a-zA-Z0-9_!#$%&*]))@([a-zA-Z0-9_]{1,20})',
          'g'
        )

        // @メンションをフィルタリング
        text = text.replace(twitterUserRegex, '$2<a href="http://x.com/$3" target="_blank">@$3</a>')

        // ハッシュタグをフィルタリング
        text = text.replace(
          hashtagRegex,
          '$2<a href="http://x.com/hashtag/$4?src=hash" target="_blank">$3$4</a>'
        )

        return $sce.trustAsHtml(text)
      }

      // Instagramの場合
      if (snsType === 'instagram') {
        // URlregex
        const inUrlRegex =
          /((((https?|ftp):\/\/)?([a-zA-Z0-9\-\.])+(\.)+(com|edu|gov|net|org|uk))|((((https?|ftp):\/\/)|(www\.))+([a-zA-Z0-9\-\.])+(\.)+(aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cs|cu|cv|cx|cy|cz|dd|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw)))(\/[-a-zA-Z\d%_.~+]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(\#[-a-zA-Z\d_]*)?(\@[-a-zA-Z\d_]*)?\b(\/)?/g

        // URLドメイン
        text = text.replace(inUrlRegex, showUrl)

        // @メンション: (exp: @aaa1111_, @aaa_bbbbb.ccc, @aaaa.bbbb.cccc, @2323232, @_aaaaa)
        const instagramUserRegex = new RegExp('@([a-zA-Z0-9_]+[a-zA-Z0-9_.]+[a-zA-Z0-9_]+)', 'g')

        // メンションをフィルタリング
        text = text.replace(
          instagramUserRegex,
          '<a href="http://www.instagram.com/$1" target="_blank">@$1</a>'
        )

        // ハッシュタグの判定を上書き
        hashtagRegex = new RegExp(
          '([#＃])([^&' + halfSizeSymbol + fullSizeSymbol + ']{1,100})',
          'g'
        )

        // ハッシュタグをフィルタリング
        text = text.replace(
          hashtagRegex,
          '<a href="http://instagram.com/explore/tags/$2" target="_blank">$1$2</a>'
        )
        return $sce.trustAsHtml(text)
      }

      // Youtubeの場合
      if (snsType === 'youtube' || snsType === 'line') {
        // URlregex
        const ytUrlRegex =
          /((((https?|ftp):\/\/)?([a-zA-Z0-9\-\.])+(\.)+(com|edu|gov|net|org|uk))|((((https?|ftp):\/\/)|(www\.))+([a-zA-Z0-9\-\.])+(\.)+(aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cs|cu|cv|cx|cy|cz|dd|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw)))(\/[-a-zA-Z\d%_.~+]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(\#[-a-zA-Z\d_]*)?(\@[-a-zA-Z\d_]*)?\b(\/)?/g

        // URLドメイン
        text = text.replace(ytUrlRegex, showUrl)
        return $sce.trustAsHtml(text)
      }

      // TikTokの場合
      if (snsType === 'tiktok') {
        // ハッシュタグの判定を上書き
        hashtagRegex = new RegExp(
          '([#＃])([^&' + halfSizeSymbol + fullSizeSymbol + ']{1,100})',
          'g'
        )

        // ハッシュタグをフィルタリング
        text = text.replace(
          hashtagRegex,
          '<a href="https://www.tiktok.com/tag/$2" target="_blank">$1$2</a>'
        )

        // @メンション
        const mentionRegex = /@([a-zA-Z0-9_]+(?:\s[a-zA-Z0-9_]+)*)/g
        text.replace(mentionRegex, (match, mention) => {
          return `<a href="https://www.tiktok.com/@${mention}" target="_blank">${match}</a>`
        })

        return $sce.trustAsHtml(text)
      }
      return $sce.trustAsHtml(text)
    }
  })
